// extracted by mini-css-extract-plugin
module.exports = {"FormResponse":"FormResponse_FormResponse__2cca6","Success":"FormResponse_Success__2_850","Failed":"FormResponse_Failed__7eMLZ"};